import React, { Component } from 'react';
import { Field, formConsumer, InputGroup, Switch } from 'core/form';
import { Box, Card, Flex, Heading, Tooltip } from 'core/components';
import { observer } from 'mobx-react';

@formConsumer
@observer
export default class CompanyPermissions extends Component {
  render() {
    const { form } = this.props;
    const { model } = form;

    const isAllAiDisabled = form.getValue('permissions.disableKentikAi') === true;

    return (
      <Flex gap={2}>
        <Box>
          <Card p={2} mb={2}>
            <Heading level="5" mb={1}>
              Kentik UI
            </Heading>
            <Flex gap={2} mb={1}>
              <Field name="permissions.portal.enabled" mb={0}>
                <Switch />
              </Field>
              <Field name="permissions.ude" mb={0}>
                <Switch />
              </Field>
              <Field name="permissions.licensingRefresh" mb={0}>
                <Switch />
              </Field>
            </Flex>

            <Flex gap={2} mb={1}>
              <Field name="permissions.kubeMap.enabled" mb={0}>
                <Switch />
              </Field>
              <Field name="permissions.linkSharing.disabled" mb={0}>
                <Switch />
              </Field>
              <Field name="permissions.kproxyCapability.enabled" mb={0}>
                <Switch />
              </Field>
              <Field name="permissions.ktrafficCapability.enabled" mb={0}>
                <Switch />
              </Field>
              <Field name="permissions.kmetaCapability.enabled" mb={0}>
                <Switch />
              </Field>
              <Field name="permissions.legacyKprobe.enabled" mb={0}>
                <Switch />
              </Field>
            </Flex>

            <Flex gap={2} mb={1}>
              <Field name="permissions.boundaryasn_override.enabled" mb={0}>
                <Switch />
              </Field>
              <Field name="permissions.segmentRouting.enabled" mb={0}>
                <Switch />
              </Field>
              <Field name="permissions.suppressLinksInExports" mb={0}>
                <Switch />
              </Field>
            </Flex>

            <Flex gap={2}>
              <Field name="permissions.dashboards.max" mb={0}>
                <InputGroup />
              </Field>
              <Field name="permissions.reportSubscriptions.max" mb={0}>
                <InputGroup />
              </Field>
            </Flex>
          </Card>

          <Card p={2} mb={2}>
            <Heading level="5" mb={1}>
              Alerting
            </Heading>
            <Flex gap={2} mb={1}>
              <Field name="permissions.alerts.limits.keysPerPolicy" mb={0}>
                <InputGroup />
              </Field>
              <Field name="permissions.alerts.limits.baselineKeysPerPolicy" mb={0}>
                <InputGroup />
              </Field>
            </Flex>
            <Flex gap={2}>
              <Field name="permissions.alerts.flowSpec.enabled" mb={0}>
                <Switch />
              </Field>
              <Field name="permissions.alerts.mit2bgp.enabled" mb={0}>
                <Switch />
              </Field>
              <Field name="permissions.alerts.nmsNative.enabled" mb={0}>
                <Switch />
              </Field>
              <Field name="permissions.alerts.eventAlerting.enabled" mb={0}>
                <Switch />
              </Field>
              <Field name="permissions.alerts.allow30sPolicyWindow" mb={0}>
                <Switch />
              </Field>
            </Flex>
          </Card>

          <Card elevation={1} p={2} mb={2}>
            <Heading level="5" mb={1}>
              Custom Dimensions
            </Heading>
            <Flex gap={2}>
              <Field name="permissions.customDimensions.maxDimensions" mb={0}>
                <InputGroup />
              </Field>
              <Field name="permissions.customDimensions.maxPopulators" mb={0}>
                <InputGroup />
              </Field>
            </Flex>
          </Card>

          <Card elevation={1} p={2}>
            <Heading level="5" mb={1}>
              Kentik AI
            </Heading>
            <Flex gap={2} mb={1}>
              <Field name="permissions.disableKentikAi" mb={0}>
                <Switch />
              </Field>
            </Flex>
            <Flex gap={2} mb={1}>
              <Field name="permissions.aiModels" mb={0} disabled={isAllAiDisabled}>
                <Switch />
              </Field>
              <Field name="permissions.kaizen" mb={0} disabled={isAllAiDisabled}>
                <Switch />
              </Field>
              <Field name="permissions.tsp" disabled={isAllAiDisabled} mb={0}>
                <Switch />
              </Field>
            </Flex>
          </Card>
        </Box>
        <Box>
          <Card elevation={1} p={2} mb={2}>
            <Heading level="5" mb={1}>
              NMS
            </Heading>
            <Flex gap={2} mb={1}>
              <Field name="permissions.recon.enabled" mb={0}>
                <Switch />
              </Field>
              <Field name="permissions.recon.useNLKMQ" mb={0}>
                <Switch />
              </Field>
              <Field name="permissions.recon.uaFlowEnrichment.enabled" mb={0}>
                <Switch />
              </Field>
            </Flex>
            <Flex gap={2}>
              <Field name="permissions.contextName.enabled" mb={0}>
                <Switch />
              </Field>
              <Field name="permissions.recon.deviceConfigFetch.enabled" mb={0}>
                <Switch />
              </Field>
              <Field name="permissions.recon.allowSpoofedCommands" mb={0}>
                <Switch />
              </Field>
            </Flex>
          </Card>

          <Card p={2} mb={2}>
            <Heading level="5" mb={1}>
              Raw Flow
            </Heading>
            <Flex gap={2}>
              <Field name="permissions.rawFlow.viewer" mb={0}>
                <Switch />
              </Field>
              <Field name="permissions.rawFlow.forensicViewer" mb={0}>
                <Switch />
              </Field>
            </Flex>
          </Card>

          <Card p={2} mb={2}>
            <Heading level="5" mb={1}>
              Service Provider
            </Heading>
            <Flex gap={2}>
              <Field name="permissions.ott.enabled" mb={0}>
                <Switch />
              </Field>
              <Field
                name="permissions.ott.projected"
                helpText={
                  <Tooltip
                    content="Enrichment flag at mn_company.company_kvs->'ott_projections' must be enabled for this feature to work."
                    target={
                      <>
                        Enrichment flag is{' '}
                        <strong>{model.get('company_kvs.ott_projections') === 'true' ? 'on' : 'off'}</strong>
                      </>
                    }
                  />
                }
                mb={0}
              >
                <Switch />
              </Field>
              <Field name="permissions.cdn.enabled" mb={0}>
                <Switch />
              </Field>
              <Field name="permissions.marketIntel.enabled" mb={0}>
                <Switch />
              </Field>
            </Flex>
          </Card>

          <Card p={2} mb={2}>
            <Heading level="5" mb={1}>
              My Kentik Portal
            </Heading>
            <Flex gap={2} mb={1}>
              <Field name="permissions.subtenancy.advancedMode" mb={0}>
                <Switch />
              </Field>
              <Field name="permissions.subtenancy.disableVizTypeChanges" mb={0}>
                <Switch />
              </Field>
            </Flex>
            <Flex>
              <Field name="permissions.subtenancy.maxTenants" mb={0}>
                <InputGroup />
              </Field>
            </Flex>
          </Card>

          <Card p={2} mb={2}>
            <Heading level="5" mb={1}>
              Synthetics
            </Heading>
            <Flex gap={2}>
              <Field name="permissions.synthetics.no_credit_limits" mb={0}>
                <Switch />
              </Field>
              <Field name="permissions.synthetics.bgpTests.enabled" mb={0}>
                <Switch />
              </Field>
              <Field name="permissions.synthetics.throughputTesting.enabled" mb={0}>
                <Switch />
              </Field>
              <Field name="permissions.synthetics.transactionTests.enabled" mb={0}>
                <Switch />
              </Field>
              <Field name="permissions.synthetics.subtestRollup.enabled" mb={0}>
                <Switch />
              </Field>
            </Flex>
            <Flex gap={2} mt={2}>
              <Field name="permissions.synthetics.dataExplorer.enabled" mb={0}>
                <Switch />
              </Field>
              <Field name="permissions.synthetics.ksynthCapability.enabled" mb={0}>
                <Switch />
              </Field>
            </Flex>
          </Card>

          <Card p={2}>
            <Heading level="5" mb={1}>
              Cloud
            </Heading>
            <Flex gap={2}>
              <Field name="permissions.cloud.metadataless_cloud_exports" mb={0}>
                <Switch />
              </Field>
            </Flex>
          </Card>
        </Box>
      </Flex>
    );
  }
}
